import { ink } from "../tokens/ink";
import { surface } from "../tokens/surface";
import { glass } from "../tokens/glass";
import { shapePill } from "../../shape";

/**
 * Spatial chip — neutral chrome for category / filter / segmented chips
 * rendered over the floor plan. Replaces brand-bordered + brand-text
 * patterns in ManuallyItems.js, ShoppingContent.js, and adjacent code.
 *
 * Idle state matches the legacy compact chip (28px) so call sites do not
 * shift on mount. Selected state mirrors galleryChipGlassActiveSx in
 * LayoutVersionSlider.js.
 */
export function getSpatialChipSx({ selected = false } = {}) {
  return {
    minWidth: "fit-content",
    height: "28px",
    padding: "4px 10px",
    borderRadius: `${shapePill} !important`,
    textTransform: "none",
    fontSize: "11px",
    whiteSpace: "nowrap",
    boxShadow: selected ? glass.shadowChipActive : "none",
    lineHeight: 1.2,
    border: selected ? surface.chipSelectedBorder : surface.chipIdleBorder,
    backgroundColor: selected
      ? surface.chipSelectedBackground
      : "#ffffff",
    color: selected ? ink.primary : ink.muted,
    fontWeight: selected ? 600 : 400,
    outline: "none",
    "&:hover": {
      backgroundColor: selected
        ? surface.chipSelectedBackground
        : "#ffffff",
    },
  };
}
